import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CommonToast from 'components/commom/CommonToast';
import { ClearTokenRedirectLogin } from 'utils/general';
import moment from 'moment';
import { getLeadCaptureDetailCallAPI } from 'store/LeadCapture/getLeadCaptureDetail/action';
import requestCheck from 'assets/images/Dashboard/chevron-right-request.svg';
import ArrowDetail from 'assets/images/Dashboard/arrow-left-request-detail.svg';
import MobileIcon from 'assets/images/Dashboard/call-request-detail.svg';
import MailIcon from 'assets/images/Dashboard/mail-request-detail.svg';
import ImageNull from 'assets/images/Dashboard/image-null.svg';
import Shimmer from 'components/commom/Shimmer';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

const LeadCaptureDetail = () => {
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();

  const leadDetail = useSelector(
    (state) => state?.getLeadCaptureDetailReducer?.users?.data
  );
  const leadDetailLoader = useSelector(
    (state) => state?.getLeadCaptureDetailReducer?.loading
  );

  const particularLeadCapture = useSelector(
    (state) => state?.basicDetailsValueReducer?.particularLeadCapture
  );

  useEffect(() => {
    if (particularLeadCapture?.id) {
      getData();
    }
  }, [particularLeadCapture]);

  const getData = () => {
    dispatch(
      getLeadCaptureDetailCallAPI(particularLeadCapture?.id, {
        run: true,
        handleFunction: (res) => {},
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainerrequest lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainerrequest lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <div className="flex pb-16">
            <div className="fs-12 lh-24 family_outfit_regular_400">
              Lead Capture
            </div>
            <div className="pl-04 flex items-center">
              <Image src={requestCheck} alt="icon" />
            </div>
            <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
              Lead Capture Details
            </div>
          </div>
          <Row className="bg-light-100 m-0 p-24">
            <Col sm={12} className="p-0">
              <div className="flex">
                <div>
                  <Image
                    src={ArrowDetail}
                    alt="icon"
                    onClick={() => navigate(-1)}
                    className="cursor-pointer"
                  />
                </div>
                <div className="fs-20 lh-252 family_outfit_semiBold_600 fc-292D32 pl-12">
                  Lead Capture Details
                </div>
              </div>
              <Row className="m-0 p-0 d-flex align-items-center">
                <Col md={4} className="p-0">
                  <div className="flex align-items-center pt-16">
                    <div className="uploadPhoto">
                      {leadDetailLoader ? (
                        <Shimmer
                          width="100px"
                          height="100px"
                          borderRadius="50%"
                        />
                      ) : (
                        <Image
                          src={
                            leadDetail?.profile_photo
                              ? leadDetail?.profile_photo
                              : ImageNull
                          }
                          alt="Uploaded profile"
                          className={
                            leadDetail?.profile_photo ? 'uploadPhoto' : ''
                          }
                        />
                      )}
                    </div>
                    <div className="pl-12">
                      {leadDetailLoader ? (
                        <Shimmer width="250px" height="20px" />
                      ) : (
                        <p className="p-0 m-0 fs-20 family_outfit_medium_500 lh-252 fc-202224">
                          {leadDetail?.full_name}
                        </p>
                      )}
                      {leadDetailLoader ? (
                        <Shimmer
                          width="250px"
                          height="20px"
                          marginTop={'12px'}
                        />
                      ) : (
                        <p className="pt-12 m-0 fs-14 family_outfit_regular_400 lh-176 fc-A4AAB2">
                          Title/Role:
                          <span className="fs-14 family_outfit_medium_500 lh-176 fc-202224 ml-[8px]">
                            {leadDetail?.title_role}
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                </Col>
                <Col md={8} className="p-0">
                  <Row className="p-0 m-0">
                    <Col md={5} className="p-0 m-0">
                      <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                        Company Name
                      </div>
                      {leadDetailLoader ? (
                        <Shimmer
                          width="250px"
                          height="20px"
                          marginTop={'8px'}
                        />
                      ) : (
                        <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                          {leadDetail?.company_organization}
                        </div>
                      )}
                    </Col>
                    <Col md={7} className="p-0 m-0">
                      <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                        Contact Info
                      </div>
                      <Stack
                        direction="horizontal"
                        gap={5}
                        className="items-center p-0"
                      >
                        {leadDetailLoader ? (
                          <Shimmer
                            width="150px"
                            height="20px"
                            marginTop={'8px'}
                          />
                        ) : (
                          <div className="flex pt-8">
                            <div>
                              <Image src={MobileIcon} alt="icon" />
                            </div>
                            <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pl-12">
                              {leadDetail?.country_code +
                                '' +
                                leadDetail?.mobile_number}
                            </div>
                          </div>
                        )}
                        {leadDetailLoader ? (
                          <Shimmer
                            width="150px"
                            height="20px"
                            marginTop={'8px'}
                          />
                        ) : (
                          <div className="flex pt-8">
                            <div>
                              <Image src={MailIcon} alt="icon" />
                            </div>
                            <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pl-12 break-all ...">
                              {leadDetail?.email}
                            </div>
                          </div>
                        )}
                      </Stack>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <div className="bg-white p-[24px] mt-[16px]">
            <div className="grid grid-cols-3 gap-[20px]">
              <div className="flex flex-col">
                <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                  Created At
                </div>
                {leadDetailLoader ? (
                  <Shimmer width="250px" height="20px" marginTop={'8px'} />
                ) : (
                  <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                    {moment(leadDetail?.created_at).format('DD MMM YYYY')}
                  </div>
                )}
              </div>
              <div className="flex flex-col">
                <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                  Identity
                </div>
                {leadDetailLoader ? (
                  <Shimmer width="250px" height="20px" marginTop={'8px'} />
                ) : (
                  <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                    {leadDetail?.user_type?.name
                      ? leadDetail?.user_type?.name
                      : 'NA'}
                  </div>
                )}
              </div>
              <div className="flex flex-col">
                <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                  Practice Type
                </div>
                {leadDetailLoader ? (
                  <Shimmer width="250px" height="20px" marginTop={'8px'} />
                ) : (
                  <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                    {leadDetail?.practice_type?.name
                      ? leadDetail?.practice_type?.name
                      : 'NA'}
                  </div>
                )}
              </div>
              <div className="flex flex-col">
                <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                  Offer Teledermatology
                </div>
                {leadDetailLoader ? (
                  <Shimmer width="250px" height="20px" marginTop={'8px'} />
                ) : (
                  <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                    {leadDetail?.offers_teledermatology?.name
                      ? leadDetail?.offers_teledermatology?.name
                      : 'NA'}
                  </div>
                )}
              </div>
              <div className="flex flex-col">
                <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                  Estimated Weekly Patient Volume
                </div>
                {leadDetailLoader ? (
                  <Shimmer width="250px" height="20px" marginTop={'8px'} />
                ) : (
                  <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                    {leadDetail?.weekly_patient_volume?.name
                      ? leadDetail?.weekly_patient_volume?.name
                      : 'NA'}
                  </div>
                )}
              </div>
              <div className="flex flex-col">
                <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                  Interest in Absolut Skin Professional Network
                </div>
                {leadDetailLoader ? (
                  <Shimmer width="250px" height="20px" marginTop={'8px'} />
                ) : (
                  <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                    {leadDetail?.professional_network_interest
                      ? leadDetail?.professional_network_interest
                      : 'NA'}
                  </div>
                )}
              </div>
              <div className="flex flex-col">
                <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                  Interested in AAD Founding Dermatologist Offer
                </div>
                {leadDetailLoader ? (
                  <Shimmer width="250px" height="20px" marginTop={'8px'} />
                ) : (
                  <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                    {leadDetail?.aad_founding_offer_interest?.name
                      ? leadDetail?.aad_founding_offer_interest?.name
                      : 'NA'}
                  </div>
                )}
              </div>
              <div className="flex flex-col">
                <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                  Interest Level
                </div>
                {leadDetailLoader ? (
                  <Shimmer width="250px" height="20px" marginTop={'8px'} />
                ) : (
                  <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                    {leadDetail?.interest_level?.name
                      ? leadDetail?.interest_level?.name
                      : 'NA'}
                  </div>
                )}
              </div>
              <div className="flex flex-col">
                <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                  Note
                </div>
                {leadDetailLoader ? (
                  <Shimmer width="250px" height="20px" marginTop={'8px'} />
                ) : (
                  <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                    {leadDetail?.note ? leadDetail?.note : 'NA'}
                  </div>
                )}
              </div>
              <div className="flex flex-col">
                <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                  Business Card
                </div>
                {leadDetailLoader ? (
                  <Shimmer width="250px" height="20px" marginTop={'8px'} />
                ) : (
                  <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                    {leadDetail?.business_card ? (
                      <Zoom>
                        <Image
                          src={leadDetail?.business_card}
                          alt="icon"
                          height={'150px'}
                          width={'150px'}
                        />
                      </Zoom>
                    ) : (
                      'NA'
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LeadCaptureDetail;
